import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { SessionService } from '../../auth/session.service';
import { Session } from '../../interfaces';
import { map, Observable } from 'rxjs';

@Component({
  selector: 'app-preferences',
  templateUrl: './preferences.component.html',
  styleUrls: ['./preferences.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PreferencesComponent {
  public readonly hasDoctorRole$: Observable<boolean> = inject(SessionService).sessionChanges.pipe(
    map(({ user }: Session) => user?.user_roles.includes('doctor')),
  );
}
